module.exports = __webpack_public_path__ + "static/media/img9.d67d9da8.jpg";